module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_8.b1ac5b3b.jpg";